import React from 'react'
import { GetSpecialPackageProducts } from '../../../features/client/clientInterface';
import { clientSpecialPackageAddTheadData } from '../../../data/admin-data';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { PRODUCT_SIZE } from '../../../constant/constant';

interface SpecialPackageAddProductTBodyProps {
    prod: GetSpecialPackageProducts[]
    isLoading: boolean
    isError: boolean
    errorMessage: string;
    isEmpty: boolean
    onClick: (product: GetSpecialPackageProducts) => void;
    selectedProductIds: Set<number>;
}

export default function SpecialPackageAddProductTBody({ selectedProductIds, onClick, prod, isLoading, isEmpty, errorMessage, isError }: SpecialPackageAddProductTBodyProps) {
    return (
        <tbody className='w-full'>
            {isLoading ? (
                <tr>
                    <td colSpan={clientSpecialPackageAddTheadData.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading product..." />
                        </div>
                    </td>
                </tr>
            ) : isError ? (
                <tr>
                    <td colSpan={clientSpecialPackageAddTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessage} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : isEmpty ? (
                <tr>
                    <td colSpan={clientSpecialPackageAddTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                prod?.map((prod, index) => {
                    const addons = prod.addons ?? []
                    const prodType = prod?.typeName.toLowerCase() === PRODUCT_SIZE.sNone.name.toLowerCase() ? '' : prod?.typeName
                    const sizeName = prod.size.toLowerCase() === PRODUCT_SIZE.sNone.name.toLowerCase() ? '' : prod.size
                    return (
                        <tr 
                            onClick={() => onClick(prod)}
                            key={prod.productID} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="flex space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={selectedProductIds.has(prod.productID)}
                                        // onChange={() => dispatch(togglePopulateSpecialPackageItem(product))}
                                        className="h-4 w-4 accent-cbColor"
                                    />
                                    <div className="truncate font-normal">
                                        {prod.productName}
                                    </div>
                                </div>
                            </th>
                            {/* <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prod.c}
                                </div>
                            </th> */}
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prodType}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {sizeName}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    ₱{prod.price}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                {addons.map((add) => (
                                    <div key={add.addonID} className="truncate font-normal flex items-center gap-2 text-xs">
                                        <span>•</span>
                                        <span>{add.addonName}</span>
                                    </div>
                                ))}
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
